import { render, staticRenderFns } from "./PaymentCC.vue?vue&type=template&id=34ba351d&"
import script from "./PaymentCC.vue?vue&type=script&lang=ts&"
export * from "./PaymentCC.vue?vue&type=script&lang=ts&"
import style0 from "./PaymentCC.vue?vue&type=style&index=0&id=34ba351d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports